import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 20px 5px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
